import Navbar from '../components/layout/Navbar';
import StockTicker from '../components/layout/StockTicker';
import Footer from '../components/layout/Footer';
import brand from '../config/brand';

export default function PrivacyPolicyPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="privacy-policy-page">
      <StockTicker />
      <Navbar />

      {/* Header */}
      <header className="py-12 border-b-2 border-black">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <h1
            className="text-4xl md:text-6xl font-black text-black tracking-tight leading-[0.95]"
            style={{ fontFamily: "'Merriweather', serif" }}
          >
            Privacy Policy
          </h1>
          <p className="text-zinc-500 mt-3 text-xs font-mono uppercase tracking-widest">Last updated: January 2026</p>
        </div>
      </header>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <div className="prose prose-lg max-w-none space-y-10">
            
            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                1. General
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Your privacy holds significant importance to us, and we offer this notice to elucidate our online information practices and the choices available to you regarding the collection and use of your personal information submitted through this Website. If you access the Website from outside the United States, please be aware that your personal data will be processed by {brand.name} in the United States, where data protection and privacy regulations may differ from those in other countries. By using the Website, you consent to the potential transfer of information outside your country if you are located outside the United States. Moreover, by utilizing the Website, you grant {brand.name} the permission to contact you electronically, in writing, or otherwise, to provide notices pertaining to your usage of the Website and to share information about products and services offered by {brand.name}. If you wish to opt out of receiving future promotional materials, you can do so by following the unsubscribe instructions provided at the end of such communications.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                2. Personally-Identifiable Information
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                In order to access services from {brand.name}, you are required to provide certain personally identifiable information (as detailed in our Terms of Service). The types of personally identifiable information that {brand.name} may collect through the Website include, but are not limited to: name, email address, cell phone number, download history, customer-generated content, and information about your interests and use of products and services. {brand.name} will not collect any personally identifiable information without your voluntary submission. Such information may be used to provide requested services, contact you about programs, products, features, or services of interest, or for other disclosed purposes. It may also be used to inform you about changes to policies, terms, or services, and to enhance the content and navigation of the Website.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                3. Access to Personal Information
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                If your personally identifiable information changes or you no longer wish to use our services, you can correct, update, delete, or deactivate it by making changes on your member information page or contacting our Customer Support. We will respond to your access request within 30 days. We retain your information as long as your account is active or as needed to provide services, comply with legal obligations, resolve disputes, and enforce agreements.
              </p>
              <div className="bg-red-600/5 border-2 border-red-600 p-4">
                <p className="text-red-600 font-mono font-bold text-xs uppercase tracking-widest">
                  INFORMATION GATHERED IN THE SMS CAMPAIGNS WILL NOT BE SHARED WITH THIRD PARTIES OR AFFILIATES FOR MARKETING PURPOSES.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                4. Cookies
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                To enhance your website experience, we employ "cookies." Cookies are alphanumeric identifiers transferred to your computer's hard drive through your web browser to enable system recognition and provide features. Cookies do not reveal your email address or other personal information unless you choose to provide it. We use cookies to understand site usage and improve content. You can erase cookies, block them, or receive warnings before storage using your browser settings. Some areas of the Website require cookies for access.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                5. Web Beacons
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Our service partners use clear gifs (Web Beacons) to better manage site content by analyzing user activity. Clear gifs are embedded invisibly on web pages, tracking online movements similar to cookies. This information is not linked to personally identifiable data.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                6. Children
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                The Website is not intended for individuals under seventeen (17) years old, and {brand.name} does not collect personally identifiable information from them, unless otherwise stated during collection.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                7. Information Collected Automatically
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                We collect non-personally-identifiable information about your Website usage, domain, access time, and linking website. This "Blind Data" helps us enhance the Website.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                8. Testimonials
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                We post customer testimonials on our site, with consent. If you wish to remove your testimonial, contact us.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                9. Public Forums
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Information shared in publicly accessible blogs or forums may be collected and used by others. To request personal information removal, contact us.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                10. Links to Other Websites
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Linked sites have different information practices. We encourage checking their privacy notices. {brand.name} is not responsible for linked sites' content, accuracy, or security.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                11. Data Security Policy
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                We implement physical, electronic, and managerial procedures to prevent unauthorized access and maintain data security. Internet communications' open nature means we cannot guarantee security.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                12. Your Acceptance of These Terms
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                By accessing the Website, you accept our Privacy Policy. Periodic updates are effective immediately upon posting on the Website.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-xl font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                13. Changes in This Privacy Policy
              </h2>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                Material changes are communicated via email or Site notice. Please review our privacy practices periodically.
              </p>
            </div>

            <div className="space-y-4 pt-8 border-t-2 border-black">
              <h3 className="text-lg font-black text-black tracking-tight" style={{ fontFamily: "'Merriweather', serif" }}>
                Questions/Concerns?
              </h3>
              <p className="text-zinc-700 leading-relaxed" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                For inquiries about our Privacy Policy, contact us at{' '}
                <a href={`mailto:${brand.legalEmail}`} className="text-red-600 hover:underline font-bold">
                  {brand.legalEmail}
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
